import { shipmentShippingServicesValidate } from "../../application/dtos/shipment_shipping_services_validate";

export class ShipmentShippingServicesEntity {
    constructor(ss){
        this.ss = ss;
    }

    isValid() {
        return shipmentShippingServicesValidate(this);
    }
}